import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import StoreSetup from 'components/Admin/StoreSetup';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <StoreSetup />
      </SiteContent>
    </ContentLayout>
  );
};
